<template>
    <div class="cart_item" :key="this_key" :class="{ _animate_in: is_new,removing: removing, 'cart_item--promo': isPromoItem }" ref="cartItem" :style="{ display: isHiddenByRemoval ? 'none' : 'block' }">
      <div class="cart_item_inner">

        <component :is="is_hidden ? 'div' : 'a'" :href="computedUrl" class="cart_item_image_col">
          <img role="presentation" class="_self_loading_image" :class="{ _loaded: itemImageLoaded, _card_styling: this.product_type === 'Gift Cards' }" :src="utils.getSizedImageUrl(image || 'https://cdn.shopify.com/s/files/1/0219/7173/0504/files/fallback.jpg', '300x')" :style="{ background: utils.getSizedImageUrl(image || 'https://cdn.shopify.com/s/files/1/0219/7173/0504/files/fallback.jpg', '1x') }" @load="() => itemImageLoaded = true" alt="">
        </component>

        <div class="cart_item_title_col">

          <div class="cart_item_title_group">
            <component :is="is_hidden ? 'div' : 'a'" :href="computedUrl">
              <span>
                {{ product_title }}
                <span v-if="shouldDisplayVariantTitle"> - {{ variant_title }}</span>
              </span>
              <div class="cart_item_option" v-if="show_variant_info" v-for="(option, index) in options_with_values">
                <div  v-if="!option.value.includes(option.name)">{{ option.name }} </div><div>{{ option.value }}</div>
              </div>
            </component>
            <div class="cart_item_loyalty_points" v-if="loyaltyPointsMessage">
              {{ loyaltyPointsMessage }}
            </div>
          </div>

          <button v-if="!isPromoItem" class="cart_item_move_to_wishlist animated_underline" title="Move to Wishlist" aria-label="Move to Wishlist" @click.prevent="e => moveToWishlist(e)"><span>Move to wishlist</span></button>

          <qty_adjuster v-if="!isPromoItem && !outOfStock" :name="`updates[${ this_key }]`" :value="quantity" :min_prop="0" :max_prop="limit ? limit : 15" :onchange="update"></qty_adjuster>
        </div>
        <div class="cart_item_price_col">
          <div class="cart_item_price_display">
            <template v-if="discounted_price < price">
              <div class="_text_strike">{{ itemPrice }}</div>
              <div class="cart_item_price_sale">
                {{ discountedPrice }}
              </div>
            </template>
            <template v-else>
              <div class="_text_strike" v-if="compareAtPriceFormatted">{{ compareAtPriceFormatted }}</div>
              <div :class="{ cart_item_price_sale: compare_at_price && compare_at_price > price }">
                {{ itemPrice }}
              </div>
            </template>
          </div>
          <button v-if="!isPromoItem" class="cart_item_delete" :aria-label="`Remove ${product_title} from cart`" @click.prevent="e => remove(e)" v-html="theme.icons.bin('100%')"></button>
        </div>
      </div>
      <cart_item_upsell v-if="upsell" :upsell="upsell" :originator="this_key" />
    </div>
</template>


<script>
  export default {
    name: 'cart_item',
    props: ['this_key', 'product_title','variant_title', 'product_type', 'adjustedPoints', 'is_new', 'url', 'image', 'show_variant_info', 'options_with_values', 'quantity', 'compare_at_price', 'price', 'discounted_price', 'upsell', 'limit', 'is_hidden', 'product_id', 'variant_id', 'properties' ],
    data () {
      return {
        itemImageLoaded: false,
        removing: false,
      }
    },
    computed: {
      itemPrice: function() {
        const { price, quantity } = this;

        if (!quantity) {
          return 'Out of stock';
        }

        const total = price * quantity;
        const { formatMoney, withCurrency } = this.$options.filters;
        return price > 0 ? withCurrency(formatMoney(total)) : 'FREE';
      },
      discountedPrice: function() {
        const { discounted_price, quantity } = this;
        const total = discounted_price * quantity;
        const { formatMoney, withCurrency } = this.$options.filters;
        return discounted_price > 0 ? withCurrency(formatMoney(total)) : 'FREE';
      },
      compareAtPriceFormatted: function() {
        const { compare_at_price, quantity } = this;
        if (!compare_at_price || compare_at_price <= this.price) return null;
        const total = compare_at_price * quantity;
        const { formatMoney, withCurrency } = this.$options.filters;
        return withCurrency(formatMoney(total));
      },
      loyaltyPointsMessage: function() {
        const { adjustedPoints } = this;

        if (!(adjustedPoints && adjustedPoints !== '')) {
          return false;
        }

        try {
          const translation = theme?.translations?.loyalty?.cart_item?.[theme.customer ? 'logged_in_points_message' : 'logged_out_points_message'];
          return translation.replace('{{ points }}', adjustedPoints);
        } catch(err) {
          console.warn(err);
        }
        return false;
      },
      outOfStock: function() {
        const { quantity } = this;
        return !quantity;
      },

       shouldDisplayVariantTitle() {
        if (this.product_type !== 'Gift Cards' || !this.variant_title) {
          return false;
        }
        const match = this.variant_title.match(/([\d,.]+)/);
        if (!match) {
          return false;
        }

        const denominationPriceInCents = parseFloat(match[1].replace(',', '')) * 100;
        const shouldDisplay = denominationPriceInCents !== this.price;
        return shouldDisplay;
      },

       computedUrl() {
       if (this.product_type === "Gift Cards" && this.product_title !== "Gift Card")  {
        return `/products/gift-card?product_id=${this.product_id}&variant_id=${this.variant_id}`;
      }
      return this.url;
    },

      isPromoItem() {
        return this.properties && this.properties._promo === 'bday25d5';
      },

      isHiddenByRemoval() {
        return this.removing;
      },

    },
    methods: {
      update: async function(quantity, errorCallback) {
        if (quantity === 0) {
          this.remove();
          return true;
        }

        const result = await window.cartUtils.updateItem(this.this_key, quantity);
        console.log(result);
        // TO DO: Change to result.error
        if (result === false) {
          errorCallback();
        }
      },
      remove: function(e) {
        const el = this.$refs.cartItem;
      if (!el) {
        window.cartUtils.removeItem(this.this_key);
        return;
      }

      const h = el.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--cart_fill_space', `${Math.ceil(h)}px`);
      el.classList.remove('_animate_in');
      void el.offsetWidth;
      el.classList.add('_animate_out');
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          window.cartUI = window.cartUI || {};
          window.cartUI.recentlyRemoved = window.cartUI.recentlyRemoved || new Set();
          window.cartUI.recentlyRemoved.add(this.this_key);
          window.cartUtils.removeItem(this.this_key);
        });
      });
      },
      moveToWishlist: async function(e) {
        const id = String(this.product_id);
        const variantId = String(this.variant_id) ?? null;
        const updatingBoard = Number(window.sessionStorage.getItem('wishlist_adding_board')) || 1;

        try {
        const add = await window.wishlist.add(id, updatingBoard, variantId);
        this.remove();
      } catch(err) {
        console.warn(err);
      }
      },
    },
  }
</script>
